exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* From: http://stackoverflow.com/a/26228354/135101 */\n.fa-spin-custom, .glyphicon-spin {\n\t-webkit-animation: spin 1000ms infinite linear;\n\tanimation: spin 1000ms infinite linear;\n}\n@-webkit-keyframes spin {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(359deg);\n\t\ttransform: rotate(359deg);\n\t}\n}\n@keyframes spin {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(359deg);\n\t\ttransform: rotate(359deg);\n\t}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./frontend/olos/styles/spin.css
// module id = 1793
// module chunks = 1